// extracted by mini-css-extract-plugin
export default {"bigBadge":"BatchBuildReport_bigBadge__T-qTb","fullBuildName":"BatchBuildReport_fullBuildName__O2Lad"};